<div class="address-details-form__form-container">
  <form [formGroup]="addressForm" (ngSubmit)="onSubmit(f)" #f="ngForm">
    <h4>Change your address details</h4>
    <br>
    <div class="address-details-form__form-container-row">
      <mat-form-field class="default-form-input-container" appearance="outline">
        <span class="address-details-form__icon"><i class="material-icons">home</i></span>
        <input matInput placeholder="Street number" formControlName="streetNumber">
      </mat-form-field>
    </div>
    <div class="address-details-form__form-container-row">
      <mat-form-field class="default-form-input-container" appearance="outline">
        <input matInput placeholder="Street name" formControlName="streetName">
      </mat-form-field>
    </div>
    <div class="address-details-form__form-container-row">
      <mat-form-field class="default-form-input-container" appearance="outline">
        <input matInput placeholder="Suburb" formControlName="suburb">
      </mat-form-field>
    </div>
    <div class="address-details-form__form-container-row">
      <mat-form-field class="default-form-input-container" appearance="outline">
        <input matInput placeholder="Town / City" formControlName="city">
      </mat-form-field>
    </div>
    <div class="address-details-form__form-container-row">
      <mat-form-field appearance="outline" class="default-form-input-container">
        <input matInput placeholder="Postcode" formControlName="postcode">
      </mat-form-field>
    </div>
    <div class="address-details-form__form-container-row">
      <mat-form-field appearance="outline" class="default-form-input-container">
        <mat-select placeholder="Country" formControlName="countryAlpha2">
          <mat-option *ngFor="let c of countryList" [value]="c.alpha2">{{ c.name }}</mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    <div *ngIf="f.dirty" class="address-details-form__form-container-row">
      <mat-checkbox formControlName="setAddressToIndividualAccounts">Apply address change to your individual managed
        fund account(s)?</mat-checkbox>
    </div>
    <div *ngIf="showFormUpdatedSuccess" class="address-details-form__form-container-row mat-form-success">
      <p class="success-text">
        <i class="material-icons">
          done
        </i>
        <span class="success-text-arrow"></span>User address updated successfully.
      </p>
    </div>
    <div class="address-details-form-footer">
      <button disableRipple class="a-rounded-button--primary a-rounded-button--medium form dialog__form-footer-button"
        type="submit" [disabled]="!f.valid || !f.dirty">{{ 'Save' }}</button>
      <button disableRipple
        class="a-rounded-button--primary-outline a-rounded-button--medium form dialog__form-footer-button" type="button"
        (click)="onResetAndClose()">{{ 'Cancel' }}</button>
    </div>
  </form>
</div>
<app-spinner *ngIf="showSpinner" class="spinner spinner_left"></app-spinner>